module.exports = __webpack_public_path__ + "media/assets/cnn-core-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/cnn-core-logo.svg
// module id = 26
// module chunks = 0